<template>
  <div class="departments">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Review Period</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>

                  <li class="breadcrumb-item active">Review Period</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a
                  href="#"
                  class="btn add-btn"
                  data-toggle="modal"
                  data-target="#add_termination_type"
                  ><i class="fa fa-plus"></i> Add Revew Period</a
                >
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div>
                <table class="table table-striped custom-table mb-0">
                  <thead>
                    <tr>
                      <th>Period</th>
                      <th>Department</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <!-- <th>Field Type</th>
                      <th>Measureable</th> -->
                      <th class="text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item) in sources" v-bind:key="item.id">
                      <td>{{ item.name }}</td>
                      <td>{{ item.department ? item.department.name : 'All Departments' }}</td>
                      <td>{{ item.startDate.split('T')[0] }}</td>
                      <td>{{ item.endDate.split('T')[0] }}</td>
                      <!-- <td>{{item.type}}</td>
                      <td><input type="checkbox" v-model="item.measureable" readonly /></td> -->
                      <td class="text-right">
                        <div
                          class="dropdown dropdown-action"
                          v-if="item.companyId != 0"
                        >
                          <a
                            href="#"
                            class="action-icon dropdown-toggle"
                            data-toggle="dropdown"
                            aria-expanded="false"
                            ><i class="material-icons">more_vert</i></a
                          >
                          <div class="dropdown-menu dropdown-menu-right">
                            <a
                              class="dropdown-item"
                              data-toggle="modal"
                              @click="selectSource(item)"
                              data-target="#edit_activity_Source"
                              ><i class="fa fa-pencil m-r-5"></i> Edit</a
                            >
                            <a
                              class="dropdown-item"
                              data-toggle="modal"
                              @click="selectSource(item)"
                              data-target="#delete_activity_Source"
                              ><i class="fa fa-trash-o m-r-5"></i> Delete</a
                            >
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Add Department Modal -->
        <div
          id="add_termination_type"
          class="modal custom-modal fade"
          role="dialog"
        >
          <div class="modal-dialog modal-dialog-x-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Add Review Period</h5>
                <button
                  type="button"
                  class="close"
                  id="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form @submit.prevent="onSubmit">
                  <div class="form-group">
                    <label>Name<span class="text-danger">*</span></label>
                    <input
                      v-model.trim="$v.name.$model"
                      id="name"
                      name="name"
                      class="form-control"
                      :class="{ 'is-invalid': submitted && $v.name.$error }"
                      type="text"
                    />
                    <div
                      v-if="submitted && !$v.name.required"
                      class="invalid-feedback"
                    >
                      Name is required
                    </div>
                  </div>
                  <div class="form-group">
                  <label>Department </label>
                  <select
                    id="department"
                    name="department"
                    class="form-control"
                    v-model="departmentId"
                  >
                    <option disabled>Select Department</option>
                    <option
                      v-for="item in departments"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                  <div class="form-group">
                    <label>Start Date<span class="text-danger">*</span></label>
                    <input
                      v-model.trim="$v.startDate.$model"
                      id="startDate"
                      name="startDate"
                      class="form-control"
                      :class="{
                        'is-invalid': submitted && $v.startDate.$error
                      }"
                      type="date"
                    />
                    <div
                      v-if="submitted && !$v.startDate.required"
                      class="invalid-feedback"
                    >
                      Start Date is required
                    </div>
                  </div>
                  <div class="form-group">
                    <label>End Date<span class="text-danger">*</span></label>
                    <input
                      v-model.trim="$v.endDate.$model"
                      id="endDate"
                      name="endDate"
                      class="form-control"
                      :class="{ 'is-invalid': submitted && $v.endDate.$error }"
                      type="date"
                    />
                    <div
                      v-if="submitted && !$v.endDate.required"
                      class="invalid-feedback"
                    >
                      End Date is required
                    </div>
                  </div>
                  <div class="form-group leave-duallist">
                    <label>Self Questions</label>
                    <div class="row">
                      <div class="col-lg-5 col-sm-5">
                        <select
                          id="SPayslip_select"
                          v-model="pickQuestions"
                          class="form-control"
                          size="8"
                          multiple="multiple"
                        >
                          <option
                            :value="item"
                            v-for="item in questions"
                            :key="item.id"
                            >{{ item.topic }}
                          </option>
                        </select>
                      </div>
                      <div class="multiselect-controls col-lg-2 col-sm-2">
                        <button
                          type="button"
                          id="SPayslip_select_rightAll"
                          @click="selectedSlipAllFrom"
                          class="btn btn-block btn-white"
                        >
                          <i class="fa fa-forward"></i>
                        </button>
                        <button
                          type="button"
                          id="SPayslip_select_rightSelected"
                          @click="selectedSlipFrom"
                          class="btn btn-block btn-white"
                        >
                          <i class="fa fa-chevron-right"></i>
                        </button>
                        <button
                          type="button"
                          id="SPayslip_select_leftSelected"
                          @click="selectedSlipTo"
                          class="btn btn-block btn-white"
                        >
                          <i class="fa fa-chevron-left"></i>
                        </button>
                        <button
                          type="button"
                          id="SPayslip_select_leftAll"
                          @click="selectedSlipAllTo"
                          class="btn btn-block btn-white"
                        >
                          <i class="fa fa-backward"></i>
                        </button>
                      </div>
                      <div class="col-lg-5 col-sm-5">
                        <select
                          id="SPayslip_select_to"
                          class="form-control"
                          size="8"
                          multiple="multiple"
                        ></select>
                      </div>
                    </div>
                  </div>
                  <div class="form-group leave-duallist">
                    <label>Manager Questions</label>
                    <!-- <div class="col-sm-6 col-md-6">
                    <div class="form-group form-focus">
                      <input
                        type="text"
                        class="form-control floating"
                        v-model="filterToSalaryGroup"
                        style="height: 55px !important"
                      />
                      <label class="focus-label">Search Manager Questions</label>
                    </div>
                  </div> -->
                    <div class="row">
                      <div class="col-lg-5 col-sm-5">
                        <select
                          id="fromGroup_select"
                          v-model="pickManagerQuestions"
                          class="form-control"
                          size="8"
                          multiple="multiple"
                        >
                          <option
                            :value="item"
                            v-for="item in mQuestions"
                            :key="item.id"
                            >{{ item.topic }}
                          </option>
                        </select>
                      </div>
                      <div class="multiselect-controls col-lg-2 col-sm-2">
                        <button
                          type="button"
                          id="fromGroup_select_rightAll"
                          @click="selectedGroupAllFrom"
                          class="btn btn-block btn-white"
                        >
                          <i class="fa fa-forward"></i>
                        </button>
                        <button
                          type="button"
                          id="fromGroup_select_rightSelected"
                          @click="selectedGroupFrom"
                          class="btn btn-block btn-white"
                        >
                          <i class="fa fa-chevron-right"></i>
                        </button>
                        <button
                          type="button"
                          id="fromGroup_select_leftSelected"
                          @click="selectedGroupTo"
                          class="btn btn-block btn-white"
                        >
                          <i class="fa fa-chevron-left"></i>
                        </button>
                        <button
                          type="button"
                          id="fromGroup_select_leftAll"
                          @click="selectedGroupAllTo"
                          class="btn btn-block btn-white"
                        >
                          <i class="fa fa-backward"></i>
                        </button>
                      </div>
                      <div class="col-lg-5 col-sm-5">
                        <select
                          id="fromGroup_select_to"
                          class="form-control"
                          size="8"
                          multiple="multiple"
                        ></select>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="form-group">
                    <label>Field Type <span class="text-danger">*</span></label>
                    <select class="form-control" v-model.trim="$v.type.$model" :class="{ 'is-invalid': submitted && $v.type.$error }">
                                                    <option disabled>Select Option</option>
                                                    <option value="string">TextField</option>
                                                    <option value="double">NumberField</option>
                                                    <option value="date">DateField</option>
                                                    <option value="bool">BooleanField</option>
                                                </select>
                    <div
                      v-if="submitted && !$v.type.required"
                      class="invalid-feedback"
                    >
                      Field Type is required
                    </div>
                  </div>
                  <div class="form-group">
                                                <label>
                                                    Measureable 
                                                </label>
                                                
                                                <div class="onoffswitch">
                                                    <input type="checkbox" v-model="measureable" name="onoffswitch" class="onoffswitch-checkbox"
                                                        id="switch_share" checked>
                                                    <label class="onoffswitch-label" for="switch_share">
                                                        <span class="onoffswitch-inner"></span>
                                                        <span class="onoffswitch-switch"></span>
                                                    </label>
                                                </div>
                                                
                                            </div>-->
                  <div class="submit-section">
                    <button class="btn btn-primary submit-btn">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- /Add Department Modal -->

        <!-- Edit Department Modal -->
        <div
          id="edit_activity_Source"
          class="modal custom-modal fade"
          role="dialog"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Edit Review Period</h5>
                <button
                  type="button"
                  class="close"
                  id="closeEdit"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="form-group">
                    <label>Name<span class="text-danger">*</span></label>
                    <input
                      v-model="source.name"
                      id="name"
                      name="name"
                      class="form-control"
                      :class="{ 'is-invalid': submitted && $v.name.$error }"
                      type="text"
                    />
                    <div
                      v-if="submitted && !$v.name.required"
                      class="invalid-feedback"
                    >
                      Name is required
                    </div>
                  </div>
                  <div class="form-group">
                  <label>Department </label>
                  <select
                    id="department"
                    name="department"
                    class="form-control"
                    v-model="source.departmentId"
                  >
                    <option disabled>Select Department</option>
                    <option
                      v-for="item in departments"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                  <div class="form-group">
                    <label>Start Date<span class="text-danger">*</span></label>
                    <input
                      v-model="source.startDate"
                      id="startDate"
                      name="startDate"
                      class="form-control"
                      :class="{
                        'is-invalid': submitted && $v.startDate.$error
                      }"
                      type="date"
                    />
                    <div
                      v-if="submitted && !$v.startDate.required"
                      class="invalid-feedback"
                    >
                      Start Date is required
                    </div>
                  </div>
                  <div class="form-group">
                    <label>End Date<span class="text-danger">*</span></label>
                    <input
                      v-model="source.endDate"
                      id="endDate"
                      name="endDate"
                      class="form-control"
                      :class="{ 'is-invalid': submitted && $v.endDate.$error }"
                      type="date"
                    />
                    <div
                      v-if="submitted && !$v.endDate.required"
                      class="invalid-feedback"
                    >
                      End Date is required
                    </div>
                  </div>
                  <!-- <div class="form-group leave-duallist">
                    <label>Self Questions</label>
                    <div class="row">
                      <div class="col-lg-5 col-sm-5">
                        <select
                          id="SPayslip_select"
                          v-model="source.reviewSelfQuestions"
                          class="form-control"
                          size="8"
                          multiple="multiple"
                          disabled
                        >
                          <option
                            :value="item"
                            v-for="item in questions"
                            :key="item.id"
                            >{{ item.topic }}
                          </option>
                        </select>
                      </div>
                      <div class="multiselect-controls col-lg-2 col-sm-2">
                        <button
                          type="button"
                          id="SPayslip_select_rightAll"
                          @click="selectedSlipAllFrom"
                          class="btn btn-block btn-white"
                          disabled
                        >
                          <i class="fa fa-forward"></i>
                        </button>
                        <button
                          type="button"
                          id="SPayslip_select_rightSelected"
                          @click="selectedSlipFrom"
                          class="btn btn-block btn-white"
                          disabled
                        >
                          <i class="fa fa-chevron-right"></i>
                        </button>
                        <button
                          type="button"
                          id="SPayslip_select_leftSelected"
                          @click="selectedSlipTo"
                          class="btn btn-block btn-white"
                          disabled
                        >
                          <i class="fa fa-chevron-left"></i>
                        </button>
                        <button
                          type="button"
                          id="SPayslip_select_leftAll"
                          @click="selectedSlipAllTo"
                          class="btn btn-block btn-white"
                          disabled
                        >
                          <i class="fa fa-backward"></i>
                        </button>
                      </div>
                      <div class="col-lg-5 col-sm-5">
                        <select
                          id="SPayslip_select_to"
                          class="form-control"
                          size="8"
                          multiple="multiple"
                          disabled
                        ></select>
                      </div>
                    </div>
                  </div>
                  <div class="form-group leave-duallist">
                    <label>Manager Questions</label>
                    <div class="row">
                      <div class="col-lg-5 col-sm-5">
                        <select
                          id="fromGroup_select"
                          v-model="source.reviewManagerQuestions"
                          class="form-control"
                          size="8"
                          multiple="multiple"
                          disabled
                        >
                          <option
                            :value="item"
                            v-for="item in mQuestions"
                            :key="item.id"
                            >{{ item.topic }}
                          </option>
                        </select>
                      </div>
                      <div class="multiselect-controls col-lg-2 col-sm-2">
                        <button
                          type="button"
                          id="fromGroup_select_rightAll"
                          @click="selectedGroupAllFrom"
                          class="btn btn-block btn-white"
                          disabled
                        >
                          <i class="fa fa-forward"></i>
                        </button>
                        <button
                          type="button"
                          id="fromGroup_select_rightSelected"
                          @click="selectedGroupFrom"
                          class="btn btn-block btn-white"
                          disabled
                        >
                          <i class="fa fa-chevron-right"></i>
                        </button>
                        <button
                          type="button"
                          id="fromGroup_select_leftSelected"
                          @click="selectedGroupTo"
                          class="btn btn-block btn-white"
                          disabled
                        >
                          <i class="fa fa-chevron-left"></i>
                        </button>
                        <button
                          type="button"
                          id="fromGroup_select_leftAll"
                          @click="selectedGroupAllTo"
                          class="btn btn-block btn-white"
                          disabled
                        >
                          <i class="fa fa-backward"></i>
                        </button>
                      </div>
                      <div class="col-lg-5 col-sm-5">
                        <select
                          id="fromGroup_select_to"
                          class="form-control"
                          size="8"
                          multiple="multiple"
                          disabled
                        ></select>
                      </div>
                    </div>
                  </div> -->
                <!-- <div class="form-group">
                  <label>Question <span class="text-danger">*</span></label>
                  <textarea
                    type="text"
                    v-model="source.topic"
                    class="form-control"
                    rows="3"
                  />
                </div> -->
                <!-- <div class="form-group">
                    <label>Field Type <span class="text-danger">*</span></label>
                    <select class="form-control" v-model="source.type">
                      <option disabled>Select Option</option>
                                                    <option value="string">TextField</option>
                                                    <option value="double">NumberField</option>
                                                    <option value="date">DateField</option>
                                                    <option value="bool">BooleanField</option>
                                                </select>
                    
                  </div>
                <div class="form-group">
                                                <label>
                                                    Measureable 
                                                </label>
                                                
                                                <div class="onoffswitch">
                                                    <input type="checkbox" v-model="source.measureable" name="onoffswitch" class="onoffswitch-checkbox"
                                                        id="switch_share" checked>
                                                    <label class="onoffswitch-label" for="switch_share">
                                                        <span class="onoffswitch-inner"></span>
                                                        <span class="onoffswitch-switch"></span>
                                                    </label>
                                                </div>
                                                
                                            </div> -->
                <div class="submit-section">
                  <button
                    class="btn btn-primary submit-btn"
                    @click="onPutSubmit"
                    data-dismiss="modal"
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Edit Department Modal -->

        <!-- Delete Department Modal -->
        <div
          class="modal custom-modal fade"
          id="delete_activity_Source"
          role="dialog"
        >
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body">
                <div class="form-header">
                  <h3>Delete Review Period</h3>
                  <p>Are you sure want to delete?</p>
                </div>
                <div class="modal-btn delete-action">
                  <div class="row">
                    <div class="col-6">
                      <a
                        class="btn btn-primary continue-btn"
                        @click="onDeleteSubmit"
                        data-dismiss="modal"
                        >Delete</a
                      >
                    </div>
                    <div class="col-6">
                      <a
                        data-dismiss="modal"
                        id="closeDelete"
                        class="btn btn-primary cancel-btn"
                        >Cancel</a
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Delete Department Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { required, sameAs } from "vuelidate/lib/validators";
import { performanceService } from "@/services/performanceService";
import { authenticationService } from "@/services/authenticationService";
import { organizationService } from "@/services/organizationService"

export default {
  components: {
    LayoutHeader,
    LayoutSidebar
  },

  data() {
    return {
      name: "",
      departmentId: null,
      pickQuestions: [],
      selectedQuestions: [],
      selectedManagerQuestions: [],
      pickManagerQuestions: [],
      departments: [],
      //   type: "",
      //   measureable: false,
      source: {},
      sources: [],
      questions: [],
      mQuestions: [],
      submitted: false,
      loading: false,
      error: "",
      company: authenticationService.currentOfficeValue
    };
  },

  validations: {
    name: { required },
    startDate: { required },
    endDate: { required }
  },

  methods: {
    selectSource(item) {
      this.source = {
        ...item,
        startDate: item.startDate ? item.startDate.split('T')[0] : '',
        endDate: item.endDate ? item.endDate.split('T')[0] : ''
      };
    },
    getDepartments() {
      organizationService.getDepartments().then(
        model => {
          this.departments = model;
          // console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    getReviewPeriods() {
      performanceService.getReviewPeriods(this.company.id).then(
        model => {
          this.sources = model;
          console.log(model);
        },
        error => {
          error = error;
        }
      );
    },

    getQuestions() {
      performanceService.getQuestionSettings(this.company.id).then(
        model => {
          this.questions = model;
          console.log(model);
        },
        error => {
          error = error;
        }
      );
    },

    onSubmit() {
      this.submitted = true;

      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.loading = true;
      // console.log('self', this.selectedQuestions);
      // console.log('manager', this.selectedManagerQuestions)
      // console.log('selfMap', this.selectedQuestions.map(q => ({ topic: q.topic })));
      // console.log('managerMap', this.selectedManagerQuestions.map(q => ({ topic: q.topic })))
      var req = {
        name: this.name,
        companyId: this.company.id,
        startDate: this.startDate,
        endDate: this.endDate,
        departmentId: this.departmentId,
        reviewSelfQuestions: this.selectedQuestions.map(q => ({ topic: q.topic })),
        reviewManagerQuestions: this.selectedManagerQuestions.map(q => ({ topic: q.topic }))
      };
      //console.log(this.name)
      performanceService.addReviewPeriod(req).then(
        id => {
          performanceService.getReviewPeriods(this.company.id).then(model => {
            this.sources = model;
            this.name = null;
            this.pickQuestions = [];
            this.selectedQuestions = [];
            this.pickManagerQuestions = [];
            this.selectedManagerQuestions = [];
            this.startDate = null;
            this.endDate = null;
            $("#close").click();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },

    onPutSubmit() {
      console.log(this.expenseType);
      this.loading = true;
      performanceService.updateReviewPeriod(this.source).then(
        id => {
          performanceService.getReviewPeriods(this.company.id).then(model => {
            this.sources = model;
            $("#closeEdit").click();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },

    onDeleteSubmit() {
      console.log(this.category);
      this.loading = true;
      performanceService.removeReviewPeriod(this.source.id).then(
        id => {
          performanceService.getReviewPeriods(this.company.id).then(model => {
            this.sources = model;
            $("#closeDelete").click();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },

    selectedSlipAllFrom() {
      var selectOption = [];
      $(document)
        .find("#SPayslip_select")
        .find("option")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#SPayslip_select_to")
        .append(selectOption);
      this.selectedQuestions = this.questions;
      this.mQuestions = [];
    },
    selectedSlipFrom() {
      var selectOption = [];
      $(document)
        .find("#SPayslip_select")
        .find("option:selected")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#SPayslip_select_to")
        .append(selectOption);
      this.selectedQuestions.push(this.pickQuestions[0]);
      this.mQuestions = this.questions.filter(q => !this.selectedQuestions.includes(x => x.topic == q.topic))
    },
    selectedSlipAllTo() {
      var selectOption = [];
      $(document)
        .find("#SPayslip_select_to")
        .find("option")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#SPayslip_select")
        .append(selectOption);

      this.selectedQuestions = [];
      this.mQuestions = this.questions;
    },
    selectedSlipTo() {
      var selectOption = [];
      var values = [];
      $(document)
        .find("#SPayslip_select_to")
        .find("option:selected")
        .each(function() {
          selectOption.push(this);
          values.push($(this).val());
        });

      $(document)
        .find("#SPayslip_select")
        .append(selectOption);

      values.forEach(v => {
        var data = JSON.parse(JSON.stringify(this.selectedQuestions));
        var index = data.indexOf(v);
        data.splice(index, 1);
        this.selectedQuestions = data;
      });
      this.mQuestions = this.questions.filter(q => !this.selectedQuestions.includes(x => x.topic == q.topic))
    },

    selectedGroupAllFrom() {
      var selectOption = [];
      $(document)
        .find("#fromGroup_select")
        .find("option")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#fromGroup_select_to")
        .append(selectOption);
      this.selectedManagerQuestions = this.questions;
    },
    selectedGroupFrom() {
      console.log(this.pickEmployees);
      var selectOption = [];
      $(document)
        .find("#fromGroup_select")
        .find("option:selected")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#fromGroup_select_to")
        .append(selectOption);
      this.selectedManagerQuestions.push(
        ...this.pickManagerQuestions
      );
    },
    selectedGroupAllTo() {
      var selectOption = [];
      $(document)
        .find("#fromGroup_select_to")
        .find("option")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#fromGroup_select")
        .append(selectOption);

      this.selectedManagerQuestions = [];
    },
    selectedGroupTo() {
      var selectOption = [];
      var values = [];
      $(document)
        .find("#fromGroup_select_to")
        .find("option:selected")
        .each(function() {
          selectOption.push(this);
          values.push($(this).val());
        });

      $(document)
        .find("#fromGroup_select")
        .append(selectOption);

      values.forEach(v => {
        var data = JSON.parse(JSON.stringify(this.selectedManagerQuestions));
        var index = data.indexOf(parseInt(v));
        data.splice(index, 1);
        this.selectedManagerQuestions = data;
        // console.log(this.selectedEmployees)
      });
    }
  },

  mounted() {
    this.getReviewPeriods();
    this.getDepartments();
    this.getQuestions();
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },

  name: "activitySource"
};
</script>



// WEBPACK FOOTER //
// src/components/review/reviewPeriod.vue